import User from 'app/scripts/models/user';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { TDispatch } from 'state';
import { kebabCase } from 'lodash-es';
import { assignRole as assignRoleApi, unassignRole as unassignRoleApi } from '../../api';
import { TGetState } from './../../../../state/store-types';
import {
  assignRoleFailure,
  assignRoleStart,
  assignRoleSuccess,
  unassignRoleFailure,
  unassignRoleStart,
  unassignRoleSuccess
} from './index';

export interface Payload {
  userId: string;
  roles: string[];
  user?: User;
}

export const assignRole = ({ user, userId, roles = [] }: Payload) => {
  return async (dispatch: TDispatch): Promise<void> => {
    dispatch(assignRoleStart({ userId }));

    try {
      await assignRoleApi({ userId, roles: roles.map(kebabCase) });
      dispatch(assignRoleSuccess({ user, userId, roles }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to assign role to user`, { userId, roles });
      dispatch(assignRoleFailure({ userId, roles }));
    }
  };
};

export const unassignRole = ({ userId, roles = [] }: Payload) => {
  return async (dispatch: TDispatch, getState: TGetState): Promise<void> => {
    const users = getState().moderation?.users.users;
    const currentUserRoles = users[userId]?.get('roles', []);
    dispatch(unassignRoleStart({ userId }));

    const rolesToUnassign = roles.filter(role => currentUserRoles.includes(role));

    if (rolesToUnassign.length < 1) {
      return;
    }

    try {
      await unassignRoleApi({ userId, roles: rolesToUnassign.map(kebabCase) });
      dispatch(unassignRoleSuccess({ userId, roles: rolesToUnassign }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to unassign role from user`, { userId, roles });
      dispatch(unassignRoleFailure({ userId, roles: rolesToUnassign }));
    }
  };
};
